import React from 'react';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';

import DateUtil from '@utils/date/util';
import classnames from 'classnames/bind';
import styles from './applyInfo.module.scss';
const cx = classnames.bind(styles);

interface ApplyInfoProps {
  positionDetail: PositionDetailVO;
}

const ApplyInfo = ({ positionDetail }: ApplyInfoProps) => {
  const { basicInfo } = positionDetail;
  const { openingDateTime, closingDateTime, openYn } = basicInfo;

  const isOpen = openYn;
  const closingDateTimeText = closingDateTime ? closingDateTime : '상시 채용';

  const getLeftDays = () => {
    if (!closingDateTime) return null;
    const days = DateUtil.getLeftDays(new Date(), new Date(closingDateTime));
    if (days < 0) return null;
    if (days === 0) return <span className={cx('badge')}>D-Day</span>;
    return <span className={cx('badge')}>D-{days}</span>;
  };

  return (
    <div className={cx('infoTextArea')}>
      <div className={cx('infoTextWrap')}>
        <span className={cx('title')}>시작일</span>
        <span className={cx('infoText')}>{openingDateTime}</span>
      </div>
      <div className={cx('infoTextWrap')}>
        <span className={cx('title')}>마감일</span>
        <span className={cx('infoText', { active: isOpen })}>{closingDateTimeText}</span>
        {getLeftDays()}
      </div>
    </div>
  );
};

export default ApplyInfo;
